import { createContext, useState, useEffect, useContext, useRef } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { BANNER_FP_EDIT_MODES } from '../../core/constants';
import { UserContext } from '../UserContext';
import { getBannerFpConfigForSite } from '../../api/bannerFpEngine';
import { initialBannerFpConfig } from '../../utilities/initialConfigs';

export const BannerFpContext = createContext();

const BannerFpProvider = ({ children }) => {
	const { user } = useContext(UserContext);
	const [bannerFpConfig, setBannerFpConfig] = useState(initialBannerFpConfig);
	const [bannerFpConfigEditMode, setBannerFpConfigEditMode] = useState(BANNER_FP_EDIT_MODES.CREATE);
	const previousFpCouchBaseConfig = useRef({});
	const { siteId } = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const pathName = location.pathname;

	useEffect(() => {
		if (!user) navigate('/login');
		if (pathName === 'banner-fp/create-config') {
			setBannerFpConfigEditMode(BANNER_FP_EDIT_MODES.CREATE);
		}
		if (pathName.includes('banner-fp/update-config')) {
			setBannerFpConfigEditMode(BANNER_FP_EDIT_MODES.UPDATE);
		}
	}, [user, pathName, navigate]);

	useEffect(() => {
		async function fetchData() {
			if (bannerFpConfigEditMode === BANNER_FP_EDIT_MODES.CREATE) return;
			if (bannerFpConfigEditMode === BANNER_FP_EDIT_MODES.UPDATE) {
				try {
					const { data } = await getBannerFpConfigForSite(siteId);
					const bannerFpConfig = data?.data?.config;
					setBannerFpConfig(bannerFpConfig);
					previousFpCouchBaseConfig.current = bannerFpConfig;
				} catch (err) {
					console.log('BannerFpContext error : ', err);
					setBannerFpConfigEditMode(BANNER_FP_EDIT_MODES.CREATE);
					navigate('/banner-fp/create-config');
				}
			}
		}
		fetchData();
	}, [bannerFpConfigEditMode, siteId, navigate]);

	return (
		<BannerFpContext.Provider
			value={{
				previousFpCouchBaseConfig,
				bannerFpConfig,
				updateBannerFpConfig: setBannerFpConfig,
				bannerFpConfigEditMode,
				updateBannerFpConfigMode: setBannerFpConfigEditMode
			}}
		>
			{children}
		</BannerFpContext.Provider>
	);
};
export default BannerFpProvider;
